import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button } from 'primereact/button'

import { Header } from '../../../../components/Header'
import { useDeliveryForecastDespatchAdviceById } from '../../data'
import { AcceptDeliveryForecastDespatchAdviceData } from './dialog'

type Props = {
  despatchAdviceId: string
  isConfirmationActive: boolean
}

export const Title: React.FC<Props> = ({
  despatchAdviceId,
  isConfirmationActive,
}) => {
  const navigate = useNavigate()

  const { data, isLoading } =
    useDeliveryForecastDespatchAdviceById(despatchAdviceId)

  const { t } = useTranslation()

  const actions = (
    <>
      <Button
        label={t('deliveryForecastDespatchAdvice.title.history.label')}
        className="p-button-text"
        onClick={() =>
          navigate(
            `/delivery-forecasts/history?search=${data?.Payload.OrderId} - ${data?.Payload.Items?.[0].OrderPosition} - ${data?.Payload.CurrentReleaseNumber}`,
          )
        }
      />

      <AcceptDeliveryForecastDespatchAdviceData
        despatchAdviceId={despatchAdviceId}
        isConfirmationActive={isConfirmationActive}
      />
    </>
  )

  return (
    <>
      <Header
        title={t('deliveryForecastDespatchAdvice.title.title', {
          scheduleAgreementNumber: data?.Payload.OrderId,
        })}
        showBackButton={true}
        showPrintButton={true}
        actions={actions}
        isLoading={isLoading}
      />
    </>
  )
}
